import {useTranslation} from "@Translation/hooks/useTranslation";
import {
    singleModalTranslationKey
} from "@SearchResults/features/staticContent/constants/translationKeys";
import TitleAndContent from "@SearchResults/features/staticContent/components/TitleAndContent";

interface TipsContentProps {
    departure: string,
    destination: string,
    availableTransportation: string,
}
function GenericTipsContent({departure, destination, availableTransportation}: TipsContentProps) {
    const title = useTranslation(
        `${singleModalTranslationKey}.tips.title`,
        {departure, destination, availableTransportation}
    )

    const content = useTranslation(
        `${singleModalTranslationKey}.tips.description`,
        {departure, destination}
    )

    return (
        <TitleAndContent
            title={title}
            content={content}
        />
    )
}

export default GenericTipsContent